<template>
	<card> 
		<ReInputList 
			class="mb-3"
			placeholder="Введите пункт"
			:bShowRB="true"
			:bShowCHB="true"
			:rb_default="rb_default"
			:CHB="chk_options"
			v-model="masOptions"
			:delMethod="{apiMethod:'DEL_NOPURPOSE_OPT_FIELD',apiParam:{obj:'BP', flt:{bp_id:-1,opt_id:-1}}}"
		/>
		<button class="btn btn-simple btn-success mr-3" @click="saveNoPurpose()">
			Сохранить
		</button>
		<button class="btn btn-simple btn-danger" @click="cancel()">
			Отмена
		</button>
	</card>
</template>
<script>
import ReInputList from 'src/our_components/ReInputList.vue'
export default {
	name: 'bp_editor_nopurpose-page',
	components: {
		ReInputList,
	},
	data() {
	    return {
			masOptions: this.currentOptions(),
			rb_default: {value:'-1'},
			chk_options:{masCHB:[]},
		};
    },
	methods: {
		currentOptions(){
			let bp_id = typeof this.$route.params.bp_id == 'undefined'?'':this.$route.params.bp_id;
			this.$GVO.ApiCall('GET_NOPURPOSE_SEL_FIELDS',{obj:'BP',flt:{'bp_id':bp_id,'for_bp':true}})
				.then((objApi) => {
					if(objApi.success === true){
						this.masOptions = objApi.data.options;
						this.rb_default.value = objApi.data.default_sel;
						this.chk_options.masCHB = objApi.data.chk_options;
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		cancel(){
			this.$router.go(-1);
		},
		saveNoPurpose(){
			let uData = {options:[],default_sel:'',chk_options:[]};
			for (let i = 0; i < this.masOptions.length; i++) {
				if(this.masOptions[i].label != ''){
					uData.options.push(this.masOptions[i]);
				}
			}
			if(uData.options.length>0){
				let bp_id = typeof this.$route.params.bp_id == 'undefined'?'':this.$route.params.bp_id;
				uData.default_sel = this.rb_default.value;
				uData.chk_options = this.chk_options.masCHB;
				this.$GVO.ApiCall('INSUPD_NOPURPOSE_SEL_FIELDS',{obj:'BP',flt:{'bp_id':bp_id},uData:uData})
					.then((objApi) => {
						/*console.log(objApi);*/
						this.$router.go(-1);
					}).catch(errorObjApi => console.error(errorObjApi));
			}
		},

	},
	mounted() {

	}
};
</script>
<style>
</style>
